import { useCurrentSpaceContext } from "@circle-react/contexts/currentSpaceContext";
import { useLocation } from "@tanstack/react-router";

import { useLessons } from "@/react/components/Spaces/CourseSpace/Lessons/Edit/hooks/useLessons";

export const useOpenChatRoomUuid = () => {
  const pathname = useLocation({ select: location => location.pathname });
  const isMessagingPage = pathname.includes("/messages");
  const { data: currentSpace } = useCurrentSpaceContext();
  const { currentLesson = {} } = useLessons({ forEdition: false });

  const chatRoomUuid = isMessagingPage
    ? window.location.pathname?.split("messages/")[1]
    : currentSpace?.chat_room_uuid || currentLesson?.chat_room_uuid;

  return { chatRoomUuid };
};
